import React from 'react'
import OptionedProductForm, {
  OptionedProductFormProps,
} from './OptionedProductForm'
import ExperienceFacetSection from 'ui-shared/Facets/FacetFormSections/ExperienceFacetSection'

export type ExperienceFormProps = OptionedProductFormProps

const ExperienceForm: React.FC<ExperienceFormProps> = (props) => {
  return (
    <OptionedProductForm facetFields={<ExperienceFacetSection />} {...props}>
      {props.children}
    </OptionedProductForm>
  )
}

export default ExperienceForm
